import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { ContactUsService } from '../core/services/contact-us.service';

@Component({
  selector: 'app-report-claim',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './report-claim.component.html',
  styleUrl: './report-claim.component.css'
})
export class ReportClaimComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  form: FormGroup;

  constructor(private fb: FormBuilder, private contactUsService: ContactUsService) {}

  get contentLabels() { return this.contactUsService.contentLabels; }

  ngOnInit() {
    this.form = this.fb.group({});
    this.formReady.emit(this.form);
  }
}   
